// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckSquareOutlinedSvg from "@fishx/icons-svg/es/asn/CheckSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var CheckSquareOutlined = function CheckSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckSquareOutlinedSvg
  }));
};

CheckSquareOutlined.displayName = 'CheckSquareOutlined';
export default React.forwardRef(CheckSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CheckSquareOutlined.js
// module id = 2204
// module chunks = 0